<template>
  <div>
    <input
      :style="{ border: warning ? '1px solid red' : '1px solid black' }"
      ref="itemInput"
      type="text"
      autocomplete="off"
      :value="item_name"
      name="item_name"
      v-on:blur="blurHandler"
      v-on:keyup="onchangeHandler"
      class="form-control"
      placeholder="item name"
    />
    <span v-if="warning" style="font-size: 0.8em; color: red"
      >You have to pick from suggestion options</span
    >
    <input autocomplete="off" name="item_id" type="hidden" />
    <div v-if="options.length" ref="suggestionBox" class="suggestion_capsule">
      <div v-for="option in options" :key="option.id">
        <article @click="optionclick(option)" class="borderit spacer">
          <span class="spacer">
            <itemname
              :ItemName="option.item_name"
              :ItemBrand="option.brand_name"
              :ItemStrength="option.item_strength"
            />
          </span>
          <span style="display: block" class="min_dull"
            >{{ option.class_name }} - {{ option.category_name }}</span
          >
          <span style="font-size: 0.8em; display: block" v-if="type != 'items'"
            >Qty: {{ option.c_quantity }} | Price:
            {{ option.cash_charge }}</span
          >
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import Itemname from "./ItemName.vue";
import { JsItemName } from "./jscomponents.js";

export default {
  name: "itemInput",
  data() {
    return {
      item_name: "",
      options: [],
      warning: false,
      chosen: false,
    };
  },

  props: {
    Store_id: [String, Number],
    Rowid: [String, Number],
    type: String,
    preselectedItem: [String, Number],
    preselectedItemID: [String, Number],
  },

  components: {
    Itemname,
  },

  methods: {
    async onchangeHandler(event) {
      this[event.target.name] = event.target.value;
      const url = "inventory/search_stock_from_store";
      const body = {
        name: event.target.value,
        store_id: this.Store_id,
        type: this.type,
      };
      const suggestions = await generalApiRequest(url, "GET", body, 1);
      this.options = suggestions;
      console.log(suggestions);

      // this.$nextTick(() => {
      //   const inputRect = this.$refs.itemInput.getBoundingClientRect();
      //   const suggestionBox = this.$refs.suggestionBox;
      //   if (suggestionBox) {
      //     suggestionBox.style.top = `${inputRect.bottom + window.scrollY}px`;
      //     suggestionBox.style.left = `${inputRect.left + window.scrollX}px`;
      //     suggestionBox.style.width = `${inputRect.width}px`;
      //   }
      // });
    },

    optionclick(option) {
      this.chosen = true;
      this.warning = false;
      const nm = JsItemName(
        option.brand_name,
        option.item_strength,
        option.item_name
      );
      this.item_name = nm;
      this.options = [];
      this.$emit("itemoption-check", option, this.Rowid);
    },

    blurHandler() {
      if (!this.chosen) {
        this.warning = true;
      } else {
        this.warning = false;
      }
      setTimeout(() => {
        this.options = [];
      }, 500);
    },

    async get_item_by_id(item_id) {
      const url = "getItemsById/" + item_id;
      const body = {};
      const data = await generalApiRequest(url, "GET", body, 1);

      if (data.data.length > 0) {
        this.optionclick(data.data[0]);
      }
    },
  },

  mounted() {
    if (this.preselectedItem) {
      this.item_name = this.preselectedItem;
    }
    if (this.preselectedItemID) {
      this.get_item_by_id(this.preselectedItemID);
    }
  },
};
</script>

<style scoped>
.suggestion_capsule {
  border: 1px solid grey;
  border-radius: 0.2em;
  z-index: 9999;
  position: absolute;
  background-color: rgb(223, 241, 241);
  max-height: 50vh;
  min-width: 350px;
  overflow-y: auto;
}

.spacer {
  padding-right: 1em;
  padding-left: 1em;
}

.min_dull {
  color: grey;
  font-size: 0.8em;
}

.borderit {
  border-bottom: 1px solid rgb(184, 212, 216);
}

.borderit:hover {
  background-color: beige;
  cursor: pointer;
}
</style>
